<template>
    <div class="app large">
        <div id="loadingAjax"></div>
        <!--Will be full width-->
        <news-heading>
            Latest Story
        </news-heading>
        <news-main :article="landingArticle"></news-main>
        <!--main content-->
        <main>
            <our-articles :articles="articles" :loading="loading" :nextPage="nextPage" :finished="finished"></our-articles>
        </main>
        <sidebar></sidebar>
        <!--Will be full width-->
        <div class="full-width">
            <lazy-component>
                <news-heading :subtitle="true">
                    Features
                </news-heading>
                <readmore :news="false" :columns="4" :amount="24"></readmore>
            </lazy-component>
        </div>
        <div class="full-width">
            <lazy-component>
                <other-news></other-news>
            </lazy-component>
        </div>
    </div>
</template>

<script>
	import Sidebar from "./sidebar.vue";
	import Readmore from "./readmore.vue";
	import Intrinsic from "../shared/intrinsic.vue";
	import Social from "../shared/social.vue";
	import Loading from "../shared/loading.vue";
	import axios from "axios";
	import OtherNews from "../news/other-news.vue";
	import Vue from "vue";
	import VueLazyload from 'vue-lazyload';
	import Tags from "./tags.vue";
	import OurArticles from "../news/our-articles.vue";
	import NewsMain from "../news/news-main.vue";
	import NewsHeading from "../news/news-heading.vue";
	import VueMasonryPlugin from 'vue-masonry';

	Vue.use(VueMasonryPlugin);

	Vue.use(VueLazyload, {
		lazyComponent: true
	});

	export default {
		name: "article",
		props: [
			"article"
		],
		watch: {
			// call again the method if the route changes
			'$route': 'scrollTop'
		},
		components: {
			Sidebar,
			Readmore,
			Intrinsic,
			Social,
			Loading,
			OurArticles,
			Tags,
			NewsMain,
			NewsHeading,
			OtherNews
		},
		created () {
			this.landingArticle = window.__landing_article;
			if (window.__readmore && window.__readmore.length) {
				this.articles = window.__readmore;
				this.currentPage = 1;
			} else {
				this.openPage(1);
			}
		},
		data: function () {
			return {
				landingArticle: {
					empty: true
				},
				articles: [],
				loading: false,
				currentPage: 0,
				finished: false,
			}
		},
		methods: {
			openPage (page, amount = 12) {
				this.currentPage = page;
				this.loading = true;
				axios.get("/wp-json/news/v2/readmore", {
					params: {
						page: page,
						amount,
						thumbnail_size: "medium",
						description: true,
						features: false,
					}
				})
					.then(({data}) => {
						if (!data.length) {
							this.finished = true;
						} else {
							this.finished = false;
							this.articles = this.articles.concat(data);
						}
					})
					.then(() => {
						this.loading = false;
					})
			},
			nextPage () {
				this.openPage(++this.currentPage);
			}
		}
	}
</script>

<style lang="scss" src="./article.scss"></style>


// WEBPACK FOOTER //
// landing.vue?cdb4a6c2